// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"202":"2ba9da4c","536":"3fa16e05","740":"5fafb3b9","855":"b040e5f9"}[chunkId] + ".css";
};